/**
 * Function to render Yes/No for boolean integer fields
 * @param {string} value - value of the field
 * @returns {"Yes" | "No"} - returns Yes/No
 */
export default function BooleanIntRender(value: string): "Yes" | "No" {
  return !!+value ? "Yes" : "No";
}
